import type { CopyShape } from "../../intl";

import type {
  SHOWCASE_FEATURE_LABELS_COPY_PT_BR,
  SHOWCASE_COUNT_LABELS_COPY_PT_BR,
  SHOWCASE_LIMIT_COPY_PT_BR,
} from "../showcase-features.copy";

export const SHOWCASE_FEATURE_LABELS_COPY_ES_ES: CopyShape<
  typeof SHOWCASE_FEATURE_LABELS_COPY_PT_BR
> = {
  "content.tasks": "Tareas",
  "content.scripts": "Guiones",
  "calendar.events": "Eventos del calendario",
  "notes.items": "Notas",

  "campaigns.jobs": "Campañas",
  "calculator.calculations": "Cálculos de publis",
  "calculator.pdf": "PDFs exportados",
  "calculator.whitelabel": "PDF sin la marca Tãmi",

  "finance.entries": "Historial financiero",
  "social.profiles": "Redes conectadas",
  "social.syncInterval": "Recogida de métricas",
  "social.history": "Historial de engagement",

  "assistant.whatsapp": "Asistente de WhatsApp",
  "assistant.messages": "Mensajes con la asistente de WhatsApp",
  "assistant.audioMinutes": "Audios transcritos en WhatsApp",
  "assistant.proactive": "Notificaciones por WhatsApp",

  "team.members": "Miembros del equipo",
  "storage.total": "Almacenamiento",
  "storage.perFile": "Tamaño por archivo",
};

export const SHOWCASE_COUNT_LABELS_COPY_ES_ES: CopyShape<
  typeof SHOWCASE_COUNT_LABELS_COPY_PT_BR
> = {
  audioMinutes: { one: "min", other: "min" },
  teamMembers: { one: "miembro", other: "miembros" },
};

export const SHOWCASE_LIMIT_COPY_ES_ES: CopyShape<
  typeof SHOWCASE_LIMIT_COPY_PT_BR
> = {
  missing: "—",
  days: (limit: number): string => (limit === 1 ? "1 día" : `${limit} días`),
  withDeadline: (value: string, days: string): string =>
    `${value} durante ${days}`,
};
